import { render, staticRenderFns } from "./_.vue?vue&type=template&id=aa93d6ee&scoped=true&"
import script from "./_.vue?vue&type=script&lang=js&"
export * from "./_.vue?vue&type=script&lang=js&"
import style0 from "./_.vue?vue&type=style&index=0&id=aa93d6ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa93d6ee",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Hero: require('/src/components/Content/Hero/Hero.vue').default,Heading: require('/src/components/PageHeading/Heading.vue').default,ArticleHero: require('/src/components/Content/Article/ArticleHero.vue').default,PostMeta: require('/src/components/Content/Article/PostMeta.vue').default,Excerpt: require('/src/components/Content/Article/Excerpt.vue').default,Aggregator: require('/src/components/Aggregator/Aggregator.vue').default,Gallery: require('/src/components/Gallery/Gallery.vue').default,ContentBlock: require('/src/components/Content/ContentBlock.vue').default,FlexibleContent: require('/src/components/Content/FlexibleContent.vue').default,PageIndex: require('/src/components/PageIndex/PageIndex.vue').default,PartnerIndex: require('/src/components/PartnerIndex/PartnerIndex.vue').default,Downloads: require('/src/components/ContentBlocks/DownloadsBlock/Downloads.vue').default,Tags: require('/src/components/Content/Article/Tags.vue').default,RelatedArticles: require('/src/components/Content/Article/RelatedArticles.vue').default})
